/** admin/families — KEYS. Query-key factory. */

export const adminFamiliesKeys = {
  all: () => ['admin-families'] as const,
  list: (params: { page: number; limit: number }) =>
    [...adminFamiliesKeys.all(), 'list', params] as const,
  devices: (id: string) => [...adminFamiliesKeys.all(), 'devices', id] as const,
  detail: (id: string) => [...adminFamiliesKeys.all(), 'detail', id] as const,
};
